import React from "react";

export default function Title(props) {

    let titulo;

    switch (props.h) {
        case 1:
            titulo = <h1>{props.text}</h1>;
            break;
        case 2:
            titulo = <h2>{props.text}</h2>;
            break;
        case 3:
            titulo = <h3>{props.text}</h3>;
            break;
        case 4:
            titulo = <h4>{props.text}</h4>;
            break;
        case 5:
            titulo = <h5>{props.text}</h5>;
            break;
        case 6:
            titulo = <h6>{props.text}</h6>;
            break;
        default:
            titulo = <h1>{props.text}</h1>;
            break;
    }

    return (
        <>{titulo}</>
    );
}
